<template>
  <div class="calendar-match" ref="calendarMatch" :class="dynamicClasses">
    <div class="date" :style="dateStyles">
      <span class="date__dayofweek">{{ formatedDate.dayOfWeek }}</span>
      <span class="date__day">{{ date.getUTCDate() }}</span>
      <span class="date__month">{{ formatedDate.month }}</span>
    </div>
    <div class="game">
      <div class="game__container">
        <div v-if="isLive" class="game-status game__live-tag">
          <span>LIVE</span>
          <span></span>
        </div>
        <span v-else-if="gameStatus === 4" class="game-status game__time">{{ time }} HRS</span>
        <span v-else class="game-status game__time">Finalizado</span>
        <div class="game__teams" :style="isPostMatch || isLive ? 'margin-top: 0.8rem' : ''">
          <div class="game__teams__team-info home">
            <div class="game__teams__logo home">
              <img
                :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teamLeft.team_id + '.png'"
                alt="logo del equipo local"
              />
              <div v-if="isCup" class="game__teams__team-info__name">
                {{ teamLeft.colloquial_name }}
              </div>
            </div>
            <div v-if="isPostMatch || isLive" class="game__teams__team-info__score">
              <div class="game__score">{{ score[0] }}</div>
              <div v-if="hasPenalties" class="penalties">({{ this.game.penalties_score_home_team }})</div>
            </div>
            <div v-else-if="!isCup" class="team-stats">
              <StatsContainer
                :titles="xgTitles"
                :contents="leftXgConent"
                :color="color"
                :background="background"
                :container-width="containerWidth"
                :is-single-game="isSingleGame"
              />
            </div>
          </div>
          <div class="game__teams__contvs" v-if="isPostMatch">
            <div class="game__teams__contvs__vs">VS</div>
            <div class="game__teams__contvs__buttom-summary" @click="setOpenMedia(game.game_id)">
              <span>Resumen</span><img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_play.png" />
            </div>
          </div>
          <div class="game__teams__vs" v-else>VS</div>

          <div class="game__teams__team-info">
            <div class="game__teams__logo">
              <img
                :src="'https://golstatsimages.blob.core.windows.net/teams-80/' + teamRight.team_id + '.png'"
                alt="logo del equipo visitante"
              />
              <div v-if="isCup" class="game__teams__team-info__name">
                {{ teamRight.colloquial_name }}
              </div>
            </div>
            <div v-if="isPostMatch || isLive" class="game__teams__team-info__score">
              <div v-if="hasPenalties" class="penalties">({{ this.game.penalties_score_visiting_team }})</div>
              <div class="game__score">{{ score[1] }}</div>
            </div>
            <div v-else-if="!isCup" class="team-stats">
              <StatsContainer
                :titles="xgTitlesReversed"
                :contents="rightXgConent"
                :color="color"
                :background="background"
                :container-width="containerWidth"
                :is-single-game="isSingleGame"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="actions__info-button" role="button" @click="onClickViewStats">
        <span>Ver</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
export default {
  name: 'CalendarMatch',
  components: {
    StatsContainer: () => import('@/components/Sections/Calendar/StatsContainer'),
  },
  props: {
    isPremiumUser: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#fff',
    },
    predictions: {
      type: Boolean,
      default: true,
    },
    background: {
      type: String,
      default: '#DBE3E6',
    },
    backgroundLive: {
      type: String,
      default: '#77a405',
    },
    isGameLive: {
      type: Boolean,
      default: false,
    },
    time: {
      type: String,
      default: '20:30',
    },
    date: {
      type: Date,
      default: () => new Date(),
    },
    teamRight: {
      type: Object,
      required: true,
    },
    teamLeft: {
      type: Object,
      required: true,
    },
    gameStatus: {
      type: Number,
      required: true,
    },
    score: {
      type: Array,
      default: () => [],
    },
    game: {
      type: Object,
      default: () => {},
    },
    percentages: {
      type: Array,
      default: () => [],
    },
    homeGoals: {
      type: Array,
      default: () => [],
    },
    visitingGoals: {
      type: Array,
      default: () => [],
    },
    probabilities: {
      type: [Object, null],
      default: () => null,
    },
    containerWidth: {
      type: Number,
      default: 634,
    },
    isSingleGame: {
      type: Boolean,
      default: false,
    },
    isCup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusOptions: {
        0: 'pending',
        1: 'live',
        2: 'finished',
      },
      probsTitles: ['GANA', 'EMPATE', 'GANA'],
      xgTitles: ['Goles', 'xG'],
    };
  },
  computed: {
    ...mapGetters('loginGeneral', ['getPremiumAccount', 'getSeasonSelected']),
    ...mapState('loginGeneral', ['tournamentsForMediaPlayer']),
    hasPenalties() {
      return this.game.penalties_score_home_team || this.game.penalties_score_visiting_team;
    },
    xgTitlesReversed() {
      return this.xgTitles.map(i => i).reverse();
    },
    leftXgConent() {
      return this.homeGoals;
    },
    rightXgConent() {
      return this.visitingGoals.map(i => i).reverse();
    },
    dateStyles() {
      return {
        color: this.color,
        background: this.isLive ? '#77a405' : '#132839',
      };
    },
    buttonStyles() {
      return {
        color: this.color,
        background: this.background,
      };
    },
    formatedDate() {
      const dayOfWeek = this.date
        .toLocaleDateString('es-ES', { weekday: 'long', timeZone: 'UTC' })
        .split(', ')[0]
        .substring(0, 3);

      const month = new Intl.DateTimeFormat('es-ES', { month: 'short', timeZone: 'UTC' })
        .format(this.date)
        .split('.')[0];

      return { month, dayOfWeek };
    },
    probsContents() {
      return this.percentages.map(p => `${p}%`);
    },
    isLive() {
      return this.gameStatus === 4 && this.isGameLive;
    },
    isPostMatch() {
      return this.gameStatus === 1 || this.gameStatus === 0;
    },
    dynamicClasses() {
      const dynamicClasses = [];
      if (this.isSingleGame) {
        dynamicClasses.push('single-game');
        if (this.containerWidth < 451) {
          dynamicClasses.push('first-break-point');
        }
      } else {
        if (this.containerWidth < 681) {
          dynamicClasses.push('first-break-point');
          if (this.containerWidth < 636) {
            dynamicClasses.push('second-break-point');
            if (this.containerWidth < 446) {
              dynamicClasses.push('third-break-point');
            }
          }
        }
      }
      return dynamicClasses;
    },
  },
  methods: {
    ...mapMutations('general', ['setPreviewSectionAnalytics']),
    ...mapMutations('mediaModal', ['setModalInitialState', 'setIsModalOpen']),
    setOpenMedia(gameId) {
      let jsonConfig = {
        seasonId: this.getSeasonSelected,
        tournaments: this.tournamentsForMediaPlayer,
        mainSectionType: 1,
        playListType: 1,
        gameIds: [gameId],
        playerIds: [],
        teamId: 0,
        matchResult: [],
        playData: {},
        advancedFilter: {},
      };
      this.setModalInitialState(jsonConfig);
      this.setIsModalOpen(true);
    },
    onClickViewStats() {
      this.$emit('action', { game: this.game.game_id, status: this.game.game_status });
      this.setPreviewSectionAnalytics('Calendar');
    },
  },
};
</script>

<style lang="scss">
.calendar-match {
  width: 100%;
  box-sizing: content-box;
  display: flex;
  font-family: Avenir-Regular, sans-serif;
  font-size: 1rem;

  & .date {
    text-align: center;
    width: 15%;
    min-width: 44px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 0.5rem;

    & * {
      cursor: default;
    }

    &__dayofweek,
    &__month {
      text-transform: uppercase;
      font-family: Avenir-Demi, sans-serif;
      font-size: 0.75rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: -0.24px;
      margin: 0.6em;
    }

    &__day {
      font-family: Circular-Std, sans-serif;
      font-size: 2.25rem;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 0.5;
      letter-spacing: -0.72px;
    }
  }

  & .game {
    width: 82%;
    display: grid;
    grid-template-columns: 1fr max-content;
    border: solid 0.8px #d2d2d2;
    border-radius: 6px;
    padding: 1em 0.5em;

    & > div {
      &:first-child {
        justify-self: center;
      }
      &.actions__info-button {
        margin-right: 1em;
      }
    }

    &__container {
      width: 100%;
      margin: 0 0.7rem;
      position: relative;
      display: flex;
      justify-content: center;

      & * {
        cursor: default;
      }
    }

    &__live-tag {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 2px auto auto;
      padding: 0 0.5em;
      border-radius: 0.3em;
      font-size: 0.8rem;
      line-height: 1.75em;
      font-weight: normal;
      font-family: Avenir-Medium, sans-serif;
      background: #3c3c3c;
      top: -0.9em;

      & span:first-child {
        color: #fff;
        padding-top: 0.1em;
      }

      & span:last-child {
        background-color: #77a405;
        height: 0.8em;
        width: 0.8em;
        border-radius: 50%;
        margin-left: 0.5em;
      }
    }

    &__time {
      display: block;
      top: -0.5em;
      font-family: Avenir-Demi, sans-serif;
      font-size: 0.875rem;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.29;
      letter-spacing: -0.28px;
      text-align: center;
      color: black;
    }

    &__teams {
      width: 100%;
      display: grid;
      grid-template-columns: 1fr max-content 1fr;
      color: #132839;

      &__team-info {
        width: 100%;
        justify-self: center;
        display: flex;
        align-items: center;
        justify-content: center;

        &__name {
          margin: 0.3em 0.25em;
          white-space: nowrap;
        }

        &__score {
          display: flex;
          justify-content: center;
          align-items: center;

          & .penalties {
            font-family: Avenir-Medium, sans-serif;
            font-size: 16px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.13;
            letter-spacing: -0.32px;
            text-align: center;
            color: #132839;
          }
        }

        &.home {
          flex-direction: row-reverse;
        }

        & .team-stats {
          width: 100%;
          max-width: 6.75rem;
        }
      }
      &__vs {
        margin: 0 1rem 0.5em;
        align-self: flex-end;
        font-family: Circular-Std-Book, sans-serif;
        font-size: 1.6875rem;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 0.67;
        letter-spacing: -0.54px;
      }
      &__contvs {
        display: inline-block;
        &__vs {
          margin: 3px 1rem 0.09rem 0.5em;
          align-self: flex-end;
          font-family: Circular-Std-Book, sans-serif;
          font-size: 1.6875rem;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.67;
          letter-spacing: -0.54px;
        }
        &__buttom-summary {
          width: 86px;
          height: 22px;
          border-radius: 25px;
          background-color: #cbee6d;
          display: inline-flex;
          font-family: 'Avenir-Medium';
          font-size: 11px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 22px;
          letter-spacing: -0.22px;
          text-align: center;
          color: #132839;
          justify-content: center;
          span {
            cursor: pointer;
          }
          & > img {
            width: 14px;
            height: 14px;
            margin-top: 4px;
            margin-left: 6px;
            cursor: pointer;
          }
          &:hover {
            cursor: pointer;
            opacity: 0.8;
          }
        }
      }

      &__logo {
        margin: 0 1rem 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;

        &.home {
          margin: 0 0 0 1rem;
        }

        & > img {
          height: 3rem;
          width: 3rem;
        }
      }

      & .game__score {
        font-family: Avenir-Bold, sans-serif;
        font-size: 2em;
        line-height: 0.2;
        padding-top: 0.2em;
        margin: 0 0.25em;
      }
    }

    &__stats {
      margin: auto;
      &-xg {
        display: flex;
        justify-content: space-between;
        width: 100%;
        & > div {
          width: 48%;
        }
      }
    }
  }

  & .actions__info-button {
    box-sizing: border-box;
    font-family: Avenir-Demi, sans-serif;
    font-size: 1rem;
    color: #132839;
    text-align: center;
    background: rgb(254, 208, 37);
    background: linear-gradient(180deg, rgba(254, 208, 37, 1) 0%, rgba(240, 178, 17, 1) 100%);
    width: 4.1rem;
    height: fit-content;
    padding: 0.8rem 1rem;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: -0.32px;
    border-radius: 7px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.19);
    cursor: pointer;
    &.live {
      background-color: #77a405;
      color: #fff;
    }
  }

  &.single-game {
    & .game {
      width: 96%;
      padding: 0 0 0.5em 0.5em;
      &__live-tag {
        top: 0.1em;
      }

      &__time {
        top: 0.8em;
        font-size: 0.875rem;
      }

      &__teams {
        margin-top: 0.8rem;
        &__team-info {
          flex-direction: column;
          align-items: center;

          & .team-stats {
            max-width: 8.875rem;
          }
        }
        &__vs {
          font-family: Circular-Std-Bold, sans-serif;
          font-size: 2rem;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.55;
          letter-spacing: -0.66px;
          margin: 1.5rem 0.5em;
          color: black;
          align-self: flex-start;
        }
        &__contvs {
          display: inline-block;
          &__vs {
            font-family: Circular-Std-Bold, sans-serif;
            font-size: 2rem;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.55;
            letter-spacing: -0.66px;
            margin: 1.5rem 1.5rem 1rem 1.5rem;
            color: black;
            align-self: flex-start;
          }
        }

        &__logo {
          margin: 0 0 0.1em 0;

          & > img {
            height: 5.5em;
            width: 5.5em;
          }

          &.home {
            margin: 0 0 0.1em 0;
          }
        }

        & .game__score {
          font-size: 2em;
          margin: 0.8em 0.3em 0.9em;
        }
      }
    }

    & .actions__info-button {
      margin-top: 1em;
    }

    &.first-break-point {
      display: grid;
      grid-template-columns: max-content 1fr;

      & .date {
        width: 2.75rem;
        border-radius: 5px;

        &__dayofweek,
        &__month {
          font-size: 0.5rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.27;
          letter-spacing: -0.14px;
          margin: 0.8em;
        }

        &__day {
          font-size: 1.125rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.72;
          letter-spacing: -0.36px;
        }
      }

      & .game {
        width: 96%;
        padding: 0.3em;

        &__live-tag {
          top: -0.2em;
          align-items: center;
          font-size: 0.6rem;

          & span:last-child {
          }
        }

        &__time {
          top: 0.3em;
          font-size: 0.6rem;
        }

        &__teams {
          margin-top: 0.3em !important;
          min-height: 5.375em;
          &__team-info {
            & .team-stats {
              max-width: 4.375rem;
            }
          }
          &__vs {
            align-self: flex-end;
            font-size: 1.125rem;
            line-height: 0.61;
            letter-spacing: -0.36px;
            margin: 0 0.5em 2.8em;
          }
          &__contvs {
            display: inline-block;
            &__vs {
              align-self: flex-end;
              font-size: 1.125rem;
              line-height: 0.61;
              letter-spacing: -0.36px;
              margin: 31px 0.5em 0.5em 0.5em;
            }
          }
          &__logo {
            margin: 0 7% 0 0;

            &.home {
              margin: 0 0 0 7%;
            }

            & > img {
              height: 2.75rem;
              width: 2.75rem;
            }
          }
        }
      }

      & .actions__info-button {
        box-sizing: border-box;
        font-size: 0.75rem;
        width: fit-content;
        height: fit-content;
        padding: 0.5em 1em 0.4em;
        border-radius: 0.2em;
        margin-top: 0;
      }
    }
  }

  &.first-break-point {
    & .date {
      width: 10%;
    }
    & .game {
      width: 87%;
    }

    &.second-break-point {
      display: grid;
      grid-template-columns: max-content 1fr;

      & .date {
        width: 2.75rem;

        &__dayofweek,
        &__month {
          font-size: 0.5rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.27;
          letter-spacing: -0.14px;
          margin: 0.8em;
        }

        &__day {
          font-size: 1.125rem;
          font-stretch: normal;
          font-style: normal;
          line-height: 0.72;
          letter-spacing: -0.36px;
        }
      }

      & .game {
        width: 98%;
        padding: 0.3em;

        &__live-tag {
          top: -0.1em;
          font-size: 0.7em;

          & span:last-child {
            height: 0.6em;
            width: 0.6em;
            margin-left: 0.5em;
          }
        }

        &__time {
          top: 0;
          font-size: 0.6rem;
        }

        &__teams {
          &__team-info {
            & .team-stats {
              max-width: 4.375rem;
            }
          }
          &__vs {
            font-size: 1.125rem;
            line-height: 0.61;
            letter-spacing: -0.36px;
            margin: 0 0.5em 0.8em;
          }
          &__contvs {
            display: inline-block;
            &__vs {
              font-size: 1.125rem;
              line-height: 0.61;
              letter-spacing: -0.36px;
              margin: 4px 0.8em 0.24em 0.8em;
            }
            &__buttom-summary {
              width: 70px;
              height: 20px;
              font-size: 9px;
              border-radius: 29px;
              & > img {
                width: 12px;
                height: 12px;
                margin-top: 4px;
                margin-left: 4px;
              }
              &:hover {
                cursor: pointer;
                opacity: 0.8;
              }
            }
          }

          &__logo {
            margin: 0 7% 0 0;

            &.home {
              margin: 0 0 0 7%;
            }

            & > img {
              height: 2.75rem;
              width: 2.75rem;
            }
          }

          & .game__score {
            font-size: 1.5em;
            padding-top: 0.2em;
          }
        }
      }

      & .actions__info-button {
        box-sizing: border-box;
        font-size: 0.75rem;
        width: fit-content;
        height: fit-content;
        padding: 0.5em 1em 0.4em;
        border-radius: 0.2em;
      }

      &.third-break-point {
        & .date {
          border-radius: 4px;
        }

        & .game {
          width: 96%;

          &__live-tag {
            top: -0.1em;
            font-size: 0.65em;

            & span:last-child {
              height: 0.6em;
              width: 0.6em;
              margin-left: 0.5em;
            }
          }

          &__time {
            top: 0;
            font-size: 0.6rem;
          }

          &__teams {
            min-height: 86px;
            &__team-info {
              flex-direction: column;
              align-items: center;

              &__score {
                align-items: flex-end;
                & .penalties {
                  font-size: 12px;
                  margin: 2px;
                }
              }
            }
            &__vs {
              margin: 0 0.5em 2.5em;
            }
            &__contvs {
              display: inline-block;
              &__vs {
                margin: 27px 0.5em 0.7em 0.5em;
              }
            }

            &__logo {
              margin: 0 0 0.1em 0;

              &.home {
                margin: 0 0 0.1em 0;
              }
            }

            & .game__score {
              font-size: 1em;
              padding-top: 0.2em;
              margin: 0.5em 0;
            }
          }
        }

        & .actions__info-button {
          margin-right: 0;
        }
      }
    }
  }
}
.game-status {
  position: absolute;
}
</style>
